export default __webpack_public_path__ + "static/media/box_3.b930dd98.jpeg";